package com.eladfinish.bible.contest.screens.search.model

enum class SearchSuggestion {
    OMIT_VAV_YUD,
    USE_NUMBER_SIGN, // SULAMIT
    WORD_BOUNDARY,
}
